import React from 'react';

const NoAccess = () => {
  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <p>You do not have permission to view this Protocol.</p>
    </div>
  );
};

export default NoAccess;